import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../data-access/services/auth.service';
import { inject } from '@angular/core';
import { Roles } from '../data-access/models/auth.model';
import { UserStore } from '../../shared/data-access/stores/user.store';
import { map } from "rxjs/operators";

const overviewerRoutes: string[] =  ['/admin'];
const hodRoutes: string[] = ['/student/application', '/student/application/renew', '/dashboard/bursaries'];
const deanRoutes: string[] = ['/dashboard/departments', '/dashboard/profiles', '/dashboard/funds'];
const studentRoutes: string[] = [
    '/student/details', '/student/bursaryInformation', '/student/documents', '/student/events', '/student/transcript',
  ];

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const userStore = inject(UserStore);

  return authService.resolveAuthState().pipe(
    map(isLoggedIn => {
      if (!isLoggedIn) {
        return false;
      }
      const rolesEnum: typeof Roles = Roles;
      const roleRoutes = new Map([
        [rolesEnum.OVERVIEWER, overviewerRoutes],
        [rolesEnum.HOD, hodRoutes],
        [rolesEnum.DEAN, deanRoutes],
        [rolesEnum.STUDENT, studentRoutes],
      ]);

      for (const [role, routes] of roleRoutes) {
        if (routes.some(route => state.url.includes(route)) && !userStore.hasRole([role])) {
          return router.createUrlTree(['unauthorised']);
        }
      }
      return true;
    })
  );
};
